import validate from 'validate.js';
import { formUpdateClassObjectiveSchema } from '../error/schemas/formUpdateClassObjective';
import { getErrors } from '../error/getErrors';
import { isValid } from '../error/isValid';

export const updateClassObjectiveErrorHandling = (objectif, field, value) => {
  let errors = objectif.errors;

  const message = validate({ [field]: value }, formUpdateClassObjectiveSchema);
  errors = getErrors(
    errors,
    field,
    message && message[field] && message[field][0]
  );

  return {
    ...objectif,
    values: {
      ...objectif.values,
      [field]: value
    },
    errors,
    isValid: isValid(errors)
  };
};
